<template>
    <component
        :is="tag"
        :href="linkHref"
        :style="tagStyle"
        class="product-sponsor-third-party-bar"
        v-if="type === 'third-party-stamp'"
    >
        {{ labels.frontendProductpage.overlay.thirdPartyText }}
    </component>
    <component
        :is="tag"
        :href="linkHref"
        :style="tagStyle"
        class="product-with-related-auction-bar"
        v-else-if="type === 'related-auction'"
    >
        <img
            src="~./auction.svg"
            data-no-block
            width="19.5"
            height="19.5"
            style="height: 1em; scale: 1.5; margin-right: 2px"
        />
        {{ labels.frontendProductpage.overlay.relatedAuctionText }}
    </component>
    <component
        :is="tag"
        :href="linkHref"
        :style="tagStyle"
        class="product-with-related-auction-bar"
        v-else-if="type === 'related-shop'"
    >
        <img
            src="~./shop.svg"
            data-no-block
            width="19.5"
            height="19.5"
            style="height: 1em; scale: 1.5; margin-right: 2px"
        />
        {{ labels.frontendProductpage.overlay.relatedShopText }}
    </component>
    <component
        :is="tag"
        :href="linkHref"
        :style="tagStyle"
        :class="['product-image-overlay', type]"
        v-else
        ><slot></slot
    ></component>
</template>

<style scoped lang="scss">
@import "common.css.src/_product-image-overlay.scss";
</style>

<script setup lang="ts">
import { computed } from "vue";
import labels from "../../../controls/shared/labels";
const props = defineProps({
    type: String,
    link: String,
});

const linkHref = computed(() => {
    if (props.link == null || props.link == "") {
        return undefined;
    }
    return props.link;
});

const tag = computed(() => {
    if (linkHref.value == null) {
        return "div";
    }
    return "a";
});

const tagStyle = computed(() => {
    if (linkHref.value != null) {
        return {
            cursor: "pointer",
            "pointer-events": "all",
        };
    }
    return undefined;
});
</script>
